export interface SignupForm {
  username: string;
  name: string;
  email: string;
  password: string;
  confirmPassword: string;
  country: string;
  gender: string;
  phoneNumber: string;
  spokenLanguages: string[];
  contributionLanguages: string[];
}

export const SUPPORTED_LANGUAGES = [
  { value: 'fr', label: 'Français', flag: '🇫🇷' },
  { value: 'ewe', label: 'Ewe', flag: '🇹🇬' },
  { value: 'mina', label: 'Mina', flag: '🇹🇬' },
  { value: 'kabye', label: 'Kabyè', flag: '🇹🇬' },
  { value: 'kotokoli', label: 'Kotokoli', flag: '🇹🇬' },
  { value: 'loso', label: 'Loso', flag: '🇹🇬' },
  { value: 'tem', label: 'Tem', flag: '🇹🇬' },
  { value: 'bassar', label: 'Bassar', flag: '🇹🇬' },
  { value: 'nawdem', label: 'Nawdem', flag: '🇹🇬' },
  { value: 'moba', label: 'Moba', flag: '🇹🇬' },
  { value: 'fon', label: 'Fon', flag: '🇧🇯' },
];

export const getGenders = (t: { male: string; female: string }) => [
  { value: 'male', label: t.male },
  { value: 'female', label: t.female },
];

export const AUTH_INPUT_CLASS = 'h-12 rounded-xl border-border/50 bg-background/60 backdrop-blur-sm transition-all focus-visible:border-primary/40 focus-visible:ring-[3px] focus-visible:ring-primary/10';
